import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// Simple smooth scroll animation
export const smoothScrollTo = (target, duration = 800, offset = 80) => {
  const targetElement = typeof target === 'string' ? document.getElementById(target) : target;
  if (!targetElement) return;

  const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
  const startPosition = window.pageYOffset;
  const distance = targetPosition - startPosition;
  let startTime = null;

  const animation = (currentTime) => {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);
    
    // Smooth easing function
    const ease = 1 - Math.pow(1 - progress, 3);
    
    window.scrollTo(0, startPosition + distance * ease);
    
    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  };

  requestAnimationFrame(animation);
};

// ScrollTransitions component that adds animation classes to children
const ScrollTransitions = ({ children }) => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Add animation classes
            entry.target.classList.add('animate-fade-in');
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            
            // Stop observing after animation
            observer.unobserve(entry.target);
          }
        });
      },
      { 
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px' 
      }
    );

    // Find all sections and add initial styles
    const sections = document.querySelectorAll('section[id]');
    sections.forEach((section) => {
      section.style.opacity = '0';
      section.style.transform = 'translateY(20px)';
      section.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out';
      observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  return <>{children}</>;
};

ScrollTransitions.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ScrollTransitions;
